import { Component, Input, OnInit } from '@angular/core';
import * as Constants from "../../utils/Constants";
import { StorageService } from 'src/app/services/storage.service';
import { ModalController } from '@ionic/angular';
import { ModalHelperService } from 'src/app/services/modal-helper';
import { calcPsi, setDefaultWindowMuntinSpacer } from 'src/app/utils/calculation';
import { EditGeorgianBarConfigComponent } from '../edit-georgian-bar-config/edit-georgian-bar-config.component';
import { CalculationAutoUpdateService } from 'src/app/services/calculation-auto-update.service';
type ConfigType = 'shapes' | 'advanced';

@Component({
  selector: 'app-edit-georgian-bar-types',
  templateUrl: './edit-georgian-bar-types.component.html',
  styleUrls: ['./edit-georgian-bar-types.component.scss'],
  standalone: false,
})
export class EditGeorgianBarTypesComponent implements OnInit {
  @Input() isComparisonMode: boolean = false;
  configType: ConfigType = 'advanced';
  barShapesData: any[] = Constants.data_muntin_types;

  selectedBar: number | null = this.barShapesData[0]?.id || null;
  storedProject: any;

  isFormValid = true;
  isShowConfiguration: boolean = false;

  constructor(private modalController: ModalController, private storageService: StorageService,
    private modalHelper: ModalHelperService, private calcAutoUpdate: CalculationAutoUpdateService
  ) { }

  ngOnInit() { 
    this.init();
  }


  ionViewWillEnter() {
    
  }

  private async init(): Promise<void> {
    try {
      const res = this.isComparisonMode
        ? await this.storageService.getComparedProject()
        : await this.storageService.getProject();
      this.storedProject = res ? JSON.parse(res) : null;

      this.configType = this.storedProject?.windowgeorgianBarType || "shapes";

      if (this.storedProject?.muntin) {
        const muntin = this.storedProject.muntin;
        if (muntin.type) {
          this.selectedBar = muntin.type?.id;
          this.updateValidateBtn(this.selectedBar);
        }
      }

    } catch (error) {
      console.error('Error initializing spacer data:', error);
    }
  }
  selectBarOpt(option: any) {
    this.selectedBar = option;
    this.updateValidateBtn(this.selectedBar);

  }
  updateValidateBtn(selectedBar: any) {
    if (selectedBar)
      var selectedMuntinTypeObj = this.findDataById(this.barShapesData, selectedBar);
    if (selectedMuntinTypeObj.id == 1 || selectedMuntinTypeObj.id == 4) {
      this.isShowConfiguration = false;
    } else if (selectedMuntinTypeObj.id == 2 || selectedMuntinTypeObj.id == 3) {
      this.isShowConfiguration = true;
    }
  }

  cancel() {
    this.modalController.dismiss(null, 'cancel');
  }

  async next() {
    var selectedMuntinTypeObj;
    if (this.selectedBar) {
      selectedMuntinTypeObj = this.findDataById(this.barShapesData, this.selectedBar);
      setDefaultWindowMuntinSpacer(this, this.storageService, this.isShowConfiguration, null, null, selectedMuntinTypeObj, this.isComparisonMode)
    }
  }

  private async saveToStorage(payload: any): Promise<void> {
    if (this.isComparisonMode) {
      await this.storageService.updateComparedProject(payload);
    } else {
      await this.storageService.updateProject(payload);
      await this.calcAutoUpdate.triggerAutoUpdate('glass', this.isComparisonMode);
    }
  }

  async updateStorage(muntin: any, isShowConfiguration: boolean) {
    await this.saveToStorage({
      "windowgeorgianBarType": this.configType,
      "muntin": muntin
    });
    if (isShowConfiguration) {
      const modal = await this.modalController.create({
        component: EditGeorgianBarConfigComponent,
        cssClass: 'configuration-modal',
        componentProps: {
          isComparisonMode: this.isComparisonMode
        }
      });

      await modal.present();

      const { data, role } = await modal.onWillDismiss();

      if (role == 'confirm') {
        console.log('Selected option:', data.selectedOption);
      }
    } else {
      //close all modals
      await this.modalHelper.closeAllModals({}, 'confirm');
    }
  }

  private findDataById(arrayData: any, id: number): any {
    return arrayData.find((obj: any) => obj.id == id);
  }

}
